module.exports = __webpack_public_path__ + "assets/img/2.533173d5.png";